module.exports = __webpack_public_path__ + "assets/img/logo_neteller.6ed3db3f.svg";